module.exports = __webpack_public_path__ + "static/img/p1.f9935fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/n-prenata-test/p1.jpg
// module id = wKVZ
// module chunks = 1